import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../Components/Sidebar';

const menu = [
  { label: 'Dashboard', path: '/' },
  { label: 'User Management', path: '/users' },
  { label: 'Car Listings', path: '/car-listings' },
  { label: 'Bookings', path: '/bookings' },
  { label: 'Invoice Records', path: '/invoices' },
  { label: 'License Management', path: '/licenses' },
];

function getLabelByPath(path) {
  const found = menu.find((item) => item.path === path);
  return found ? found.label : 'Dashboard';
}

function TopNavbar({ title }) {
  return (
    <div className="z-[9999] sticky top-0 w-full py-7 px-8 text-lg font-semibold  bg-[#121212]">
      {title}
    </div>
  );
}

const MainLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeLabel, setActiveLabel] = useState(getLabelByPath(location.pathname));

  const handleMenuSelect = (label, path) => {
    setActiveLabel(label);
    navigate(path);
  };

  return (
    <div className="min-h-screen bg-[#121212] text-white">
      {/* Fixed Sidebar */}
      <div className="fixed top-0 left-0 h-full z-30">
        <Sidebar activeLabel={activeLabel} onMenuSelect={handleMenuSelect} />
      </div>
      {/* Main Content Area */}
      <div className="ml-[284px] min-h-screen flex flex-col">
        <TopNavbar title={activeLabel} />
        <div className="flex-1">
          {children}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
